/* Panthera hero video — seamless loop.
   The native `loop` attribute hard-cuts back to frame zero. This
   clones each hero video and crossfades between the two copies at the
   loop point, so the restart is invisible. If JS fails, the original
   `loop` attribute (left untouched until setup runs) still works. */
(() => {
  const FADE_S = 1.2;

  function setup(video) {
    if (!video || video.dataset.smoothLoop) return;
    video.dataset.smoothLoop = 'active';

    const clone = video.cloneNode(true);
    clone.dataset.smoothLoop = 'clone';
    clone.muted = true;
    clone.autoplay = false;
    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');

    let active = video;
    let standby = clone;
    let swapping = false;

    [video, clone].forEach((v) => {
      v.loop = false;
      v.style.transition = `opacity ${FADE_S}s linear`;
    });
    clone.style.opacity = '0';
    video.style.opacity = '1';
    video.after(clone);

    function maybeSwap() {
      const v = active;
      if (swapping || !v.duration || Number.isNaN(v.duration)) return;
      if (v.currentTime < v.duration - FADE_S) return;

      swapping = true;
      standby.currentTime = 0;
      const playing = standby.play();
      if (playing && playing.catch) playing.catch(() => {});
      standby.style.opacity = '1';
      active.style.opacity = '0';

      setTimeout(() => {
        active.pause();
        const t = active;
        active = standby;
        standby = t;
        swapping = false;
      }, FADE_S * 1000);
    }

    video.addEventListener('timeupdate', maybeSwap);
    clone.addEventListener('timeupdate', maybeSwap);

    /* Safety net: if a video stalls at its end (timeupdate can stop
       firing right at the boundary), restart the pair. */
    [video, clone].forEach((v) => {
      v.addEventListener('ended', () => {
        if (v === active && !swapping) {
          v.currentTime = 0;
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        }
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('video.hero-video__el').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
